/*
* @providesModule EmailManagementStyle
*
*/

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';
import SKZConstants from 'SKZConstants';

import {
  Platform,
  StyleSheet,
} from 'react-native';

const {
  fontMedium,
  fontRegular,
  fontSizeH1,
  fontSizeH4,
  fontSizeH5,
  textColorPrimary,
  viewCornerRadiusSecondary,
  fontSecondary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  flexOne: {
    flex: 1,
  },

  container: {
    flex: 1,
    backgroundColor: '#FFF',
  },

  landscapePhoneContainer: {
    flex: 1,
    width: 374,
    marginTop: 22,
    backgroundColor: '#FFF',
    borderTopLeftRadius: viewCornerRadiusSecondary.borderRadius,
    borderTopRightRadius: viewCornerRadiusSecondary.borderRadius,
    alignSelf: 'center',
    overflow: 'hidden',
  },

  tabletContainer: {
    flex: 1,
    width: SKZConstants.TABLET_USABLE_AREA_WIDTH_PERCENT,
    marginVertical: 150,
    alignSelf: 'center',
    borderRadius: viewCornerRadiusSecondary.borderRadius,
    backgroundColor: '#FFF',
    overflow: 'hidden',
  },

  mustVerifyContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: Sizes.select({
      tablet: 70,
      other: 60,
    }),
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
  },

  mustVerifyText: {
    ...fontRegular,
    ...fontSizeH4,
    color: '#ACACAC',
  },

  rightButtonText: {
    ...fontMedium,
    ...fontSizeH4,
    ...textColorPrimary,
  },

  rightButton: {
    height: 18,
    paddingRight: 16,
  },

  plusSign: {
    ...fontRegular,
    ...fontSizeH1,
    marginBottom: 4,
    marginRight: 8,
    color: 'rgb(74, 144, 226)',
  },

  blueText: {
    ...fontMedium,
    ...fontSizeH4,
    color: 'rgb(74, 144, 226)',
  },

  addEmailContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: Sizes.select({
      tablet: 76,
      other: 56,
    }),
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
  },

  footer: {
    height: 45,
    backgroundColor: 'rgb(245, 245, 245)',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },

  divider: {
    backgroundColor: 'rgba(172, 172, 172, 0.2)',
    height: 1,
    marginHorizontal: Sizes.select({
      tablet: 40,
      other: 14,
    }),
  },

  primaryEmailCell: {
    marginLeft: 44,
  },

  addEmailInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: Sizes.select({
      tablet: 100,
      other: 83,
    }),
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
  },

  addEmailInputWrapper: {
    flex: 1,
    paddingBottom: 10,
  },

  addEmailInput: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(51, 51, 51)',
    ...Platform.select({
      web: {
        outlineStyle: "none",
        zIndex: 1,
      }
    }),
  },

  addEmailLabel: {
    ...fontRegular,
    ...fontSizeH5,
    color: 'rgb(172, 172, 172)',
  },

  addEmailInputButton: {
    width: 72,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 1,
    borderColor: 'rgb(74, 144, 226)',
    marginLeft: 24,
    ...Platform.select({
      web: {
        boxSizing: 'content-box',
      }
    }),
  },

  addEmailInputButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: 'rgb(74, 144, 226)',
  },

});
